import { useRef } from "react";
import { useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import GlobalDialog from "../../../../components/core/global-dialog";
import { DownloadButton } from "../../../../components/core";
import { formatDate, formatDateYYYYMMDD } from "../../../../algorithms/date";
import { getStatusWithSuspendedCheck } from "../../../../utils/agent-helpers";

const headerClassName =
  "bg-primary-primaryYellow border border-gray-400 text-center text-secondary-purpleGray";
const cellClassName = "border border-gray-200 text-center";

export default function StatusHistoryModal({
  isOpen,
  onClose,
  statusHistory = [],
}) {
  console.log({ statusHistory });
  const dt = useRef(null);
  const today = new Date();

  // const statusHistory = useSelector(
  //   (state) => state.agentProfile.agentStatusHistory,
  // );

  return (
    <GlobalDialog
      visible={isOpen}
      onHide={onClose}
      closable={true}
      dialogHeader="Agent Status History"
      dialogClassName="max-w-[95%] md:w-[950px]"
    >
      <div>
        <div className="flex items-center justify-between px-5 py-3 bg-primary-primaryYellow">
          <span className="font-semibold text-sm text-secondary-purpleGray">
            Total:{" "}
            <span className="font-semibold">{statusHistory?.length ?? 0}</span>
          </span>
          <DownloadButton
            dt={dt}
            csvOnly={true}
            exportFilename={`agent-status-history-${formatDateYYYYMMDD(today)}`}
            containerBgColor="bg-transparent"
            containerClassName="!p-0"
          />
        </div>

        <DataTable
          value={statusHistory}
          showGridlines
          paginator
          rows={10}
          removableSort
          stripedRows
          ref={dt}
        >
          <Column
            header="Agent Status"
            field="agentStatus"
            alignHeader="center"
            headerClassName={headerClassName}
            className={`${cellClassName} font-semibold`}
            body={(rowData) => (
              <div className="flex justify-center">
                <Tag
                  className={`text-secondary-purpleGray text-xs ${
                    rowData.agentStatus === 1
                      ? "bg-green-400"
                      : rowData.agentStatus === -1 &&
                          rowData.comments?.toLowerCase().includes("suspended")
                        ? "bg-orange-400"
                        : rowData.agentStatus === -1
                          ? "bg-red-400"
                          : "bg-gray-400"
                  }`}
                >
                  {getStatusWithSuspendedCheck(
                    rowData.agentStatus,
                    rowData.comments,
                  )}
                </Tag>
              </div>
            )}
          />
          <Column
            header="Msg to Agent"
            field="agentStatusComments"
            alignHeader="center"
            headerClassName={headerClassName}
            className={cellClassName}
          />
          <Column
            header="Private Comments"
            field="comments"
            alignHeader="center"
            headerClassName={headerClassName}
            className={cellClassName}
          />
          <Column
            header="Status Date"
            field="createdAt"
            alignHeader="center"
            headerClassName={headerClassName}
            className={cellClassName}
            body={(rowData) => <div>{formatDate(rowData.createdAt)}</div>}
          />
        </DataTable>
      </div>
    </GlobalDialog>
  );
}
